var catalogFilters = angular.module("catalogFilters", []);
catalogFilters.run(["$rootScope", function ($rootScope) {}]);
catalogFilters.controller("filterDesktop", [
  "$scope",
  "$http",
  "$filter",
  "$rootScope",
  "$q",
  function ($scope, $http, $filter, $rootScope, $q) {
    $scope.filters = false;
    $scope.sort = "asc";
    $scope.showCount = false;
    $scope.count = 0;
    $scope.$on("filterMobile.changed", (event, val) => {
      $scope.filters = val.filters;
      $scope.sort = val.sort;
    });
    $scope.expand = (selector) => {
      var root = document.querySelector(selector);
      var expandElements = root.querySelectorAll(".filter_expand_on_load");
      expandElements.forEach((item) => {
        var trigger = item.querySelector(".accordion__trigger");
        trigger.click();
      });
    };
    $scope.toggle = (field, id) => {
      $scope.filters["hardcode_filters"][field].values[id] =
        !$scope.filters["hardcode_filters"][field].values[id];
      $scope.numbers();
    };
    $scope.watcher = () => {
      $rootScope.$broadcast("filterDesktop.changed", {
        filters: $scope.filters,
        sort: $scope.sort,
      });
    };
    $scope.numbers = () => {
      $scope.watcher();
      $scope.showCount = false;
      urlParams = $scope.getFiltersString();
      $.get(
        document.location.pathname + "?" + urlParams.join("&") + "&count=1",
        (data) => {
          $scope.count = parseInt(data);
          $scope.showCount = true;
          $scope.$apply();
        }
      );
    };
    $scope.resets = () => {
      // console.log("desktop resets");
      var $groupKeys = Object.keys($scope.filters);
      for (var $groupKey in $groupKeys) {
        // groupKeys[ groupKey ] = group::attribute-name
        var $group = $scope.filters[$groupKeys[$groupKey]];
        var $propKeys = Object.keys($group);
        for (var $propKey in $propKeys) {
          // propKeys[ propKey ] = field::attribute-name
          var $prop = $group[$propKeys[$propKey]]; // values - md5(value) -> ngmodels, decode - md5(value) -> valueName
          if (!$prop) {
            continue;
          }
          switch ($prop.type) {
            case "relation":
              $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                $prop.values[$itemCode] = 0;
              }
              break;
            case "price":
              $prop.from_value = $prop.from;
              $prop.to_value = $prop.to;
              break;
            case "boolean":
              $prop.value = 0;
              break;
            case "rowbox":
              $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                $prop.values[$itemCode] = 0;
              }
              break;
            default:
          }
        }
      }
      $scope.sort = "asc";
      $scope.watcher();
      $scope.apply();
    };
    $scope.apply = () => {
      // console.log("desktop apply");
      urlParams = $scope.getFiltersString();
      var url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        urlParams.join("&");
      // console.log("query: " + url);
      if (history.pushState) window.history.pushState({ path: url }, "", url);
      $.get(url, (data) => {
        $(".categories__content").html(data);
      });
    };
    $scope.getFiltersString = () => {
      var urlParams = [];
      var $groupKeys = Object.keys($scope.filters);
      for (var $groupKey in $groupKeys) {
        // groupKeys[ groupKey ] = group::attribute-name
        var $group = $scope.filters[$groupKeys[$groupKey]];
        var $propKeys = Object.keys($group);
        for (var $propKey in $propKeys) {
          // propKeys[ propKey ] = field::attribute-name
          var $prop = $group[$propKeys[$propKey]]; // values - md5(value) -> ngmodels, decode - md5(value) -> valueName
          if (!$prop) {
            continue;
          }

          switch ($prop.type) {
            case "relation":
              var $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                if ($prop.values[$itemCode]) {
                  // is checked
                  urlParams.push(
                    "filter[" +
                      $propKeys[$propKey] +
                      "][]=" +
                      encodeURI($prop.decode[$itemKeys[$itemKey]])
                  );
                }
              }
              break;
            case "price":
              urlParams.push(
                "filter[" + $propKeys[$propKey] + "][from]=" + $prop.from_value
              );
              urlParams.push(
                "filter[" + $propKeys[$propKey] + "][to]=" + $prop.to_value
              );
              break;
            case "boolean":
              if ($prop.value)
                urlParams.push(
                  "filter[" + $propKeys[$propKey] + "][]=" + $prop.value
                );
              break;
            case "rowbox":
              var $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                if ($prop.values[$itemCode]) {
                  // is checked
                  urlParams.push(
                    $propKeys[$propKey] +
                      "[]=" +
                      encodeURI($prop.decode[$itemKeys[$itemKey]])
                  );
                }
              }
              break;
            default:
          }
        }
      }
      urlParams.push("sort=" + $scope.sort);
      return urlParams;
    };
  },
]);
catalogFilters.controller("filterMobile", [
  "$scope",
  "$http",
  "$filter",
  "$rootScope",
  "$q",
  function ($scope, $http, $filter, $rootScope, $q) {
    $scope.filters = false;
    $scope.sort = "asc";
    $scope.$on("filterDesktop.changed", (event, val) => {
      $scope.filters = val.filters;
      $scope.sort = val.sort;
    });
    $scope.expand = (selector) => {
      var root = document.querySelector(selector);
      var expandElements = root.querySelectorAll(".filter_expand_on_load");
      expandElements.forEach((item) => {
        var trigger = item.querySelector(".accordion__trigger");
        trigger.click();
      });
    };
    $scope.watcher = () => {
      $rootScope.$broadcast("filterMobile.changed", {
        filters: $scope.filters,
        sort: $scope.sort,
      });
    };
    $scope.numbers = () => {
      $scope.watcher();
    };
    $scope.resets = () => {
      // console.log("mobile resets");
      var $groupKeys = Object.keys($scope.filters);
      for (var $groupKey in $groupKeys) {
        // groupKeys[ groupKey ] = group::attribute-name
        var $group = $scope.filters[$groupKeys[$groupKey]];
        var $propKeys = Object.keys($group);
        for (var $propKey in $propKeys) {
          // propKeys[ propKey ] = field::attribute-name
          var $prop = $group[$propKeys[$propKey]]; // values - md5(value) -> ngmodels, decode - md5(value) -> valueName
          if (!$prop) {
            continue;
          }
          switch ($prop.type) {
            case "relation":
              $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                $prop.values[$itemCode] = 0;
              }
              break;
            case "price":
              $prop.from_value = $prop.from;
              $prop.to_value = $prop.to;
              break;
            case "boolean":
              $prop.value = 0;
              break;
            case "rowbox":
              $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                $prop.values[$itemCode] = 0;
              }
              break;
            default:
          }
        }
      }
      $scope.sort = "asc";
      $scope.watcher();
      $scope.apply();
    };
    $scope.apply = () => {
      console.log("mobile apply");
      urlParams = $scope.getFiltersString();
      var url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        urlParams.join("&");
      if (history.pushState) window.history.pushState({ path: url }, "", url);
      $.get(url, (data) => {
        $(".categories__content").html(data);
      });
    };
    $scope.getFiltersString = () => {
      var urlParams = [];
      var $groupKeys = Object.keys($scope.filters);
      for (var $groupKey in $groupKeys) {
        // groupKeys[ groupKey ] = group::attribute-name
        var $group = $scope.filters[$groupKeys[$groupKey]];
        var $propKeys = Object.keys($group);
        for (var $propKey in $propKeys) {
          // propKeys[ propKey ] = field::attribute-name
          var $prop = $group[$propKeys[$propKey]]; // values - md5(value) -> ngmodels, decode - md5(value) -> valueName
          if (!$prop) {
            continue;
          }
          switch ($prop.type) {
            case "relation":
              var $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                if ($prop.values[$itemCode]) {
                  // is checked
                  urlParams.push(
                    "filter[" +
                      $propKeys[$propKey] +
                      "][]=" +
                      encodeURI($prop.decode[$itemKeys[$itemKey]])
                  );
                }
              }
              break;
            case "price":
              urlParams.push(
                "filter[" + $propKeys[$propKey] + "][from]=" + $prop.from_value
              );
              urlParams.push(
                "filter[" + $propKeys[$propKey] + "][to]=" + $prop.to_value
              );
              break;
            case "boolean":
              if ($prop.value)
                urlParams.push(
                  "filter[" + $propKeys[$propKey] + "][]=" + $prop.value
                );
              break;
            case "rowbox":
              var $itemKeys = Object.keys($prop.values);
              for (var $itemKey in $itemKeys) {
                // itemKeys[ itemKey ] = node:item::md5( value )
                $itemCode = $itemKeys[$itemKey];
                if ($prop.values[$itemCode]) {
                  // is checked
                  urlParams.push(
                    $propKeys[$propKey] +
                      "[]=" +
                      encodeURI($prop.decode[$itemKeys[$itemKey]])
                  );
                }
              }
              break;
            default:
          }
        }
      }
      urlParams.push("sort=" + $scope.sort);
      return urlParams;
    };
  },
]);
